export default "__VITE_ASSET__Cgw5vnGu__"